import React from 'react';
import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { Icon } from '@components/shared/Icon';
import { useSlideMenuContext } from '../context/NavbarContext';

export interface NavbarSlideMenuItemProps {
  title: string | React.ReactNode;
  menuContent: React.ReactNode;
  menuHeader?: React.ReactNode;
  type?: NavbarSlideMenuItemType;
}

type NavbarSlideMenuItemType = 'menuItem' | 'subMenuItem';

export const NavbarSlideMenuItem: React.FC<NavbarSlideMenuItemProps> = ({
  title,
  menuHeader,
  menuContent,
  type = 'menuItem',
}) => {
  const { openSlideMenu } = useSlideMenuContext();

  return (
    <li
      data-testid="navbar-slide-menu-item"
      aria-selected="false"
      css={[listItemStyles, type === 'subMenuItem' && subMenuItemStyles]}
      onClick={() => openSlideMenu({ header: menuHeader || title, content: menuContent })}
    >
      <span css={titleStyles}>{title}</span>
      <Icon type="chevron-right" size="medium" />
    </li>
  );
};

const titleStyles = css({
  fontSize: '16px',
  fontWeight: 400,
});

const listItemStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  color: token('color.text'),
  padding: `0 ${token('space.300')}`,
  paddingRight: '18px',
  height: '32px',

  '&:hover': {
    color: token('color.link'),
  },
});

const subMenuItemStyles = css({
  padding: `0 18px 0 ${token('space.500')}`,
});
